<template>
  <div>
    <div
      :id="id"
      :class="className"
      :style="{ height: height, width: width }"
    />
  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  props: {
    className: {
      type: String,
      default: "chart",
    },
    id: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "300px",
    },
    DataDoughnut: {
      type: Array,
      default() {
        return [];
      },
    },
    labelGraph: {
      type: Array,
      default() {
        return [];
      },
    },
    Color: {
      type: Array,
      default() {
        return [];
      },
    },
    Name: {
      type: String,
      default: "Graph",
    },
    Setup: {
      type: Boolean,
      default: false,
    },
    visualMaps: {
      type: Object,
      default: null,
    },
    isShowGraph: {
      type: Boolean,
      default: false,
    },
    isTooltip: {
      type: Boolean,
      default: false,
    },
    axisPointerColor: {
      type: String,
      default: "#7581BD",
    },
    unitName: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      chart: null,
      dataTests: {
        categories: [
          "Shirt",
          "Wool sweater",
          "Chiffon shirt",
          "Pants",
          "High-heeled shoes",
          "socks",
        ],
        values: [5, 20, 36, 10, 10, 20],
      },
      labels_graph: null,
    };
  },
  mounted() {
    setTimeout(() => {
      this.initChart();
    }, 500);
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  watch: {
    DataDoughnut: "initChart",
  },
  methods: {
    initChart() {
      let tooltip = {
        trigger: "axis",
        formatter: function (params) {
          return params[0].data[1];
        },
      };

      var option = {
        tooltip: this.isTooltip == true ? tooltip : null,
        xAxis: {
          type: "category",
          data: this.labelGraph,
          axisLabel: {
            rotate: 30,
          },
        },
        yAxis: {
          type: "value",
          name: this.unitName,
          scale: true,
          axisLabel: {
            formatter: function (value) {
              return Intl.NumberFormat("en-US", {
                maximumFractionDigits: 1,
                notation: "compact",
                compactDisplay: "short",
              }).format(value);
            },
            fontSize: 10,
          },
        },
        grid: {
          left: "12%",
        },
        visualMap: this.visualMaps,
        series: this.DataDoughnut,
        textStyle: {
          fontFamily: "Kanit",
        },
      };

      this.chart = echarts.init(document.getElementById(this.id));

      this.chart.setOption(option);
    },
  },
};
</script>
